import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { Outlet, useLocation } from "react-router-dom";
// import { screenChange } from "../../store/screenSlice";
import FindMemberMenu from "../../components/FindMember/FindMemberMenu";
import ReactModal from "react-modal";
import VideoHistoryReport from "../../components/reports/VideoHistoryReport";
import CLEHistoryReport from "../../components/reports/CLEHistoryReport";
import MembershipSummaryReport from "../../components/reports/MembershipSummaryReport";
import { changeAdminUserScreen } from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";
import AdminUserComponent from "../../components/configuration/AdminUserComponent";
import ConfigurationHeader from "../../components/configuration/ConfigurationHeader";
import AdminUserCreation from "../../components/configuration/AdminUserCreation";
import ReportHeader from "../../components/reports/ReportHeader";
import ReconcileReport from "../../components/reports/ReconcileReport";
import JobScreen from "../../components/reports/JobScreen";
import MemberCodeAdvancementReport from "../../components/reports/MemberCodeAdvancementReport";
import MembershipPendingPaymentReport from "../../components/reports/MembershipPendingPaymentReport";
// import "./Order.css";

const Reports: React.FC = () => {
  /* const dispatch = useDispatch();

  const [viewMembershipSummaryModalOpen, setViewMembershipSummaryModalOpen] =
    useState(false);
  const [viewCLEHistoryModalOpen, setViewCLEHistoryModalOpen] = useState(false);
  const [viewVideoHistoryModalOpen, setViewVideoHistoryModalOpen] =
    useState(false);

  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-content-wrapper">
        <h1 className="page-heading">Reports</h1>
        <div
          className="report-label report-div"
          style={{ marginTop: "1rem" }}
          onClick={() => setViewMembershipSummaryModalOpen(true)}
        >
          Membership Accounting Summary
        </div>
        <div
          className="report-label report-div"
          style={{ marginTop: "1rem" }}
          onClick={() => setViewCLEHistoryModalOpen(true)}
        >
          CLE history
        </div>
        <div
          className="report-label report-div"
          style={{ marginTop: "1rem" }}
          onClick={() => setViewVideoHistoryModalOpen(true)}
        >
          Video History
        </div>
      </div>

      <ReactModal
        isOpen={viewMembershipSummaryModalOpen}
        onRequestClose={() => setViewMembershipSummaryModalOpen(false)}
        className="editinfo-modal-large overflow-auto"
        overlayClassName="overlay-dark"
      >
        <MembershipSummaryReport
          callBackClose={() => setViewMembershipSummaryModalOpen(false)}
        />
      </ReactModal>

      <ReactModal
        isOpen={viewCLEHistoryModalOpen}
        onRequestClose={() => setViewCLEHistoryModalOpen(false)}
        className="editinfo-modal-large overflow-auto"
        overlayClassName="overlay-dark"
      >
        <CLEHistoryReport
          callBackClose={() => setViewCLEHistoryModalOpen(false)}
        />
      </ReactModal>

      <ReactModal
        isOpen={viewVideoHistoryModalOpen}
        onRequestClose={() => setViewVideoHistoryModalOpen(false)}
        className="editinfo-modal-large overflow-auto"
        overlayClassName="overlay-dark"
      >
        <VideoHistoryReport
          callBackClose={() => setViewVideoHistoryModalOpen(false)}
        />
      </ReactModal>
    </div>
  ); */

  const dispatch = useDispatch();
  // dispatch(screenChange("Settings"));
  const currentConfigurationMenu = useSelector(
    (state: RootState) => state.screen.currentConfigurationMenu
  );

  // useEffect(() => {
  //   dispatch(changeAdminUserScreen(screenConfig.adminUserListScreen));
  // }, []);

  const renderConfigurationMenu = () => {
    if (currentConfigurationMenu === screenConfig.adminUserConfiguration) {
      return <ReconcileReport />;
    }
    if (currentConfigurationMenu === screenConfig.jobConfiguration) {
      return <JobScreen />;
    }
    if (currentConfigurationMenu === screenConfig.memberCodeAdvancementConfiguration) {
      return <MemberCodeAdvancementReport />;
    }
    if (currentConfigurationMenu === screenConfig.pendingPaymentsConfiguration) {
      return <MembershipPendingPaymentReport />;
    }
  };

  return (
    <div className="dashboard-wrapper" style={{ display: 'inline-block' }}>
      {/* <div className="p-4 w-100 h-100 border border-secondary"> */}
      <ReportHeader />
      {renderConfigurationMenu()}
      {/* </div> */}
    </div>
  );
};

export default Reports;
